import qs from 'qs';
import { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { FiltersStoreType } from "src/store/dashboard/filters.store";
import { Conta } from "src/store/global.store.types";

export interface IndicadoresResponse {
  valor_comissionamento: number
  total_propostas: number
  ticket_medio_gerador: number
  valor_total_geradores: number
  potencia_total_geradores_kw: number
  potencia_media_geradores_kw: number
  valor_servico: number
}

export interface GraficosResponse {
    data: string
    total_propostas: number
    total_valor_comissionamento: number
    total_valor_servico: number
    total_valor_projetos: number
}

class DashboardProvider extends AProvider {
    constructor() {
        super("/dashboard");
    }

    filterNonNullValues(obj: object){
        return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v))
    }

    formatDate(date: string, type: 'start' | 'end'): string {
        if (!date) return ''
        const onlyDate = date.includes("T") ? date.split("T")[0] : date.split(' ')[0]
        const [ano, mes, dia] = onlyDate.split('-')
        return `${ano}-${mes}-${dia}T${type === 'start' ? '00:00:00' : '23:59:59'}`
    }

    formatFilters(filters: FiltersStoreType | null): string {
        const requestFilters = {
            distribuidor_id: filters?.distribuidor?.id,
            revenda_id: filters?.revenda?.id,
            created_at_more_equal: filters?.startDate ? this.formatDate(filters.startDate, 'start') : '',
            created_at_less_equal: filters?.endDate ? this.formatDate(filters.endDate, 'end') : '',
        }

        if (filters?.statusProjeto){
            Object.assign(requestFilters, {
                [filters.statusProjeto.field]: filters.statusProjeto.value,
            })
        }
        /*if (filters?.etapaVenda) {
            Object.assign(requestFilters, {
                [filters.etapaVenda.field]: filters.etapaVenda.value,
            })

            if (filters.etapaVenda.not_in_field) {
                Object.assign(requestFilters, {
                    [filters.etapaVenda.not_in_field]: filters.etapaVenda.not_in_query,
                })
            }
        }*/

        return qs.stringify(this.filterNonNullValues(requestFilters))
    }

    async buscarIndicadores(filters: FiltersStoreType | null): Promise<IndicadoresResponse | null> {
        try {
            const queryString = this.formatFilters(filters)

            const request: IDataRequest = {
                url: `${this.path}/indicadores${queryString ? `?${queryString}` : ''}`,
                data: {},
            }

            const response: IDataResponse<IndicadoresResponse> = await apiNoLoading.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data
            }

            return null
          } catch (error) {
            return null
        }
    }

    async buscarGraficos(filters: FiltersStoreType | null){
        try {
            const queryString = this.formatFilters(filters)

            const request: IDataRequest = {
                url: `${this.path}/graficos${queryString ? `?${queryString}` : ''}`,
                data: {},
            }

            const response: IDataResponse<GraficosResponse[]> = await apiNoLoading.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data
            }

            return null
          } catch (error) {
            return null
        }
    }
    async listarDistribuidores(){
        try {
            const request: IDataRequest = {
                url: `${this.path}/distribuidores?filtrar_todos=true`,
            }

            const response: IDataResponse<Conta[]> = await apiNoLoading.get(request);

            if (response.statusCode === STATUS_CODE.OK) {
                return response.data
            }

            return null
          } catch (error) {
            return null
        }
    }
}

export { DashboardProvider }